import React, { useState } from 'react';
import { number } from 'prop-types';
import { Card } from '@one-thd/sui-atomic-components';
import classNames from 'classnames';
import { dataModel } from '../../dataModels/dataModel';
import { useContainerWidth } from '../../hooks/useContainerWidth';
import { defaultCardContentProps } from '../../constants/responsiveClassNames';
import { useSplitQuotesByStatus } from '../../hooks/useSplitQuotesByStatus';
import QuotesHeader from './QuotesHeader';
import QuotesContent from './QuotesContent';
import { useQuoteContext } from '../../hooks/useQuoteContext';

const Quotes = ({ maxListSize }) => {

  // Use the QuotesContext to access quotes directly
  const { quoteList } = useQuoteContext();
  const quotes = quoteList?.quotes || [];
  // We can add a loading placeholder here instead of showing the no quote component while data is being fetched
  const [selectedTab, setSelectedTab] = useState('active');
  const [ref, containerWidth] = useContainerWidth();
  const { activeQuotes, expiredQuotes } = useSplitQuotesByStatus(quotes);

  const hasQuotes = quotes && quotes.length > 0;
  const showTabs = activeQuotes.length > 0 && expiredQuotes.length > 0;

  return (
    <Card
      data-component="Quotes"
      data-testid="quotes-container"
      className="sui-@container"
      CardContentProps={{ className: classNames(defaultCardContentProps, 'sui-w-full') }}
      ref={ref}
    >
      <QuotesHeader hasQuotes={hasQuotes} />
      <QuotesContent
        activeQuotes={activeQuotes}
        containerWidth={containerWidth}
        expiredQuotes={expiredQuotes}
        hasQuotes={hasQuotes}
        maxListSize={maxListSize}
        quotes={quotes}
        selectedTab={selectedTab}
        setSelectedTab={setSelectedTab}
        showTabs={showTabs}
      />
    </Card>
  );
};

Quotes.propTypes = {
  maxListSize: number,
};

Quotes.defaultProps = {
  maxListSize: 3,
};

Quotes.displayName = 'Quotes';
Quotes.dataModel = dataModel;

export { Quotes };